<template>
  <div>
    <el-dialog title="行程图片" :visible.sync="dialogVisible" width="35%" >
      <div v-if="budget&&budget.imageUrl&&budget.imageUrl!=''" style="justify-content: center;display: flex;align-items: end;">
        <el-image style="width: 100px; height: 100px" :src="budget.imageUrl" :preview-src-list="[budget.imageUrl]"></el-image>
        <el-button type="danger" style="margin-left:0.2rem" icon="el-icon-delete" circle @click="deleteBudgetImage"></el-button>
      </div>
      <div v-else>
        <upload ref="uploadVue"></upload>
      </div>
      <div class="planEditor">
        <Ueditor class="myUeditor" style="height:100vh" ref="ueditor" :parentId="budget.id"></Ueditor>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="upload" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import upload from '../children/upload.vue'
import Ueditor from "@/components/Editor/Ueditor.vue";
export default {
  components: {upload, Ueditor},
  data() {
    return {
      dialogVisible: false,
      budget: {},
      fullscreenLoading: false,
    }
  },
  methods: {
    openDialog(budget) {
      this.dialogVisible = true
      this.budget = budget;
      this.$nextTick(() => {
        this.$refs.ueditor.setUeContent(budget.planCharatDesc)
        // this.$refs.uploadVue.file = {}
      })
    },
    upload() {
      var postNumber = 0
      this.$refs.ueditor.getContent().then(res => {
        this.budget.planCharatDesc = res
        new PlanApi("plan").updateBudgetMain({id: this.budget.id, planCharatDesc: res}).then((res) => {
          if (res.status === 200) {
            postNumber++;
            if(postNumber==2){
              this.$message.success("保存成功");
              this.dialogVisible = false
            }
          }
        })
      })
      if (this.$refs.uploadVue&&this.$refs.uploadVue.fileList.length>0) {
        this.fullscreenLoading = true;
        const form = new FormData();
        form.append("file", this.$refs.uploadVue.fileList[0].raw); // 第三个参数为文件名
        form.append("budgetMainId", this.budget.id); // 第三个参数为文件名
        new PlanApi('plan').uploadBudgetFile(form).then((res) => {
          this.fullscreenLoading = false;
          if (res.status === 200) {
            postNumber++;
            this.budget.imageUrl = res.data
            if(postNumber==2){
              this.$message.success("上传成功");
              this.dialogVisible = false
            }
          }
        }).catch(er => {
          this.fullscreenLoading = false;
        });
      }else{
        postNumber++;
      }
    },
    deleteBudgetImage() {
      new PlanApi('plan').deleteBudgetFile({budgetMainId: this.budget.id}).then((res) => {
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.budget.imageUrl = ""
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.planEditor {
  margin-top: 0.2rem;
}

  .myUeditor {
      /deep/.edui-editor {
        position: sticky;
        top: 0;
        height: 600px;
        overflow: scroll;
      }
      /deep/ .edui-editor-toolbarbox {
        position: sticky;
        top: 0;
        z-index: 9999;
      }
      /deep/.ueditor-box {
      }
    }
</style>
